import * as React from 'react';
import * as autoBind from 'react-autobind';
import {PopoverButton, TscButtonType, Glyphs, TscButtonGlyphPlacement} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';
import {SortMetric} from '../../globals/Constants';
import SortingsMenu from '../SortingsMenu/SortingsMenu';

export default class SortDirectionButton extends React.Component<SortDirectionButtonProps, {}> {
   constructor(props: SortDirectionButtonProps) {
      super(props);
      autoBind(this);
   }

   getSortStrings() {
      const {sortMetric} = this.props;
      if (sortMetric === SortMetric.titleAscending) {
         return Strings.labels.sortDirectionButton.title.ascending;
      } else if (sortMetric === SortMetric.titleDescending) {
         return Strings.labels.sortDirectionButton.title.descending;
      } else if (sortMetric === SortMetric.createdDateAscending) {
         return Strings.labels.sortDirectionButton.date.ascending;
      } else {
         return Strings.labels.sortDirectionButton.date.descending;
      }
   }

   render() {
      const {sortMetric, setSortMetric} = this.props;
      const sortStrings = this.getSortStrings();

      return (
         <div className="review-sort-direction-popover">
            <PopoverButton
               buttonType={TscButtonType.tertiary}
               themeName={this.props.themeName}
               buttonText={ `${Strings.labels.sortDirectionButton.preText}: ${sortStrings.label}`}
               buttonTitle={sortStrings.title}
               testId="sort-direction-button"
               popoverMenu={<SortingsMenu sortMetric={sortMetric} setSortMetric={setSortMetric} />}
               width="11rem"
               buttonGlyph={<Glyphs.CaratDown16x16/>}
               glyphPlacement={TscButtonGlyphPlacement.right}
               closeMenuOnClick={true}
            />
         </div>
      );
   }
}

export interface SortDirectionButtonProps extends Themeable {
   sortMetric: SortMetric;
   setSortMetric(sortMetric: SortMetric): void;
}
